import React from "react";

const Dashboard = () => {
  return <h2>Dashboard Page 🚀</h2>;
};

export default Dashboard;